import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-upload',
  templateUrl: './progress-upload.component.html',
  styleUrls: ['./progress-upload.component.scss']
})
export class ProgressUploadComponent {
  @Input() progress = 0;

  constructor() { }
}
